import { http } from 'services';

export * from './api-auth-invitation';

// Authentication - Login, payload: email, password, remember_me, return_user
export function authLogin(payload, cbSuccess, cbError) {
  http.post(
    'auth/login',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Authentication - Pre-login, params: email
export function authPreLogin(query, cbSuccess, cbError) {
  http.get(
    'auth/pre-login',
    query,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Authentication - Forgot password
export function authForgotPassword(payload, cbSuccess, cbError) {
  http.post(
    'auth/forgot-password',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Authentication - Refresh token
export function authRefreshToken(cbSuccess, cbError) {
  http.get(
    'auth/refresh',
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Authentication - Check email
export function authEmailCheck(params, cbSuccess, cbError) {
  http.get(
    'auth/email-check',
    params,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Authentication - Verify email
export function authVerifyEmail(payload, cbSuccess, cbError) {
  http.post(
    'auth/verify-email',
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Authentication - Create password, payload: email, password, confirm_password, token
export function authActivateAccount(payload, cbSuccess, cbError) {
  http.post(
    'auth/activate-account',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Authentication - Reset password, payload: email, password, confirm_password, token
export function authResetPassword(payload, cbSuccess, cbError) {
  http.post(
    'auth/reset-password',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Authentication - Instance info
export function authInstanceInfo(query, cbSuccess, cbError) {
  http.get(
    'auth/instance-info',
    query,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-authentication/index.js